import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { getAiChatOutlineStyle } from 'src/utils/dnd/getItemStyle'
import EditIcon from '@material-ui/icons/EditOutlined'
import DeleteIcon from '@material-ui/icons/DeleteOutlined'
import DragIcon from '@material-ui/icons/DragIndicatorOutlined'
import { Box } from '@material-ui/core'
import SubHeaders from './sub-headers'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { CoreTextField, CoreButton } from 'src/components/core'
import { track } from '@amplitude/analytics-browser'
import AddIcon from '@material-ui/icons/Add'

const OutlineList = props => {
  const { classes, data, setData, outlineId, titles } = props
  const inputFocus = id => {
    document.getElementById(id).focus()
  }

  const onDragEnd = result => {
    if (!result.destination) return

    const { source, destination, type } = result
    const newData = [...data.sections]

    if (type === 'SECTION') {
      const [movedModule] = newData.splice(source.index, 1)
      newData.splice(destination.index, 0, movedModule)
    } else if (type === 'MODULE') {
      const sourceModuleIndex = parseInt(source.droppableId.split('-')[1])
      const destinationModuleIndex = parseInt(
        destination.droppableId.split('-')[1],
      )

      const sourceModule = newData[sourceModuleIndex]
      const destinationModule = newData[destinationModuleIndex]

      const [movedSection] = sourceModule.modules.splice(source.index, 1)

      if (sourceModuleIndex === destinationModuleIndex) {
        sourceModule.modules.splice(destination.index, 0, movedSection)
      } else {
        destinationModule.modules.splice(destination.index, 0, movedSection)
      }
    }

    // Update state immutably
    const updatedData = {
      ...data,
      sections: newData,
    }

    setData(updatedData)
  }

  const handleSubHeaderItemChange = (e, moduleIndex, sectionIndex) => {
    const newData = [...data.sections]
    newData[moduleIndex].modules[sectionIndex].module_title = e.target.value
    setData({ ...data, sections: newData })
  }

  const handleHeaderItemChange = (e, moduleIndex) => {
    const newData = [...data.sections]
    newData[moduleIndex].section_title = e.target.value
    setData({ ...data, sections: newData })
  }

  const addOwnSubheader = moduleIndex => {
    const newData = [...data.sections]
    newData[moduleIndex].modules.push({
      module_title: '',
      content_type: 'info',
    })
    track('ai_chat_outline_edit', {
      action: 'add_own_subheader_outline',
    })
    setData({ ...data, sections: newData })
  }

  const deleteSubheader = (moduleIndex, sectionIndex) => {
    const newData = [...data.sections]
    newData[moduleIndex].modules.splice(sectionIndex, 1)
    track('ai_chat_outline_edit', {
      action: 'delete_subheader_outline',
    })

    setData({ ...data, sections: newData }) // Ensure the state is updated after the Redux store
  }
  const deleteHeader = moduleIndex => {
    track('ai_chat_outline_edit', {
      action: 'delete_header_outline',
    })
    const newData = [...data.sections]
    newData.splice(moduleIndex, 1)
    setData({ ...data, sections: newData }) // Ensure the state is updated after the Redux store
  }

  const addOwnHeader = () => {
    const newData = [...data.sections]
    newData.push({
      section_title: ' ',
      modules: [
        {
          module_title: ' ',
          content_type: 'info',
        },
      ],
    })
    track('ai_chat_outline_edit', {
      action: 'add_own_header_outline',
    })
    setData({ ...data, sections: newData })
  }
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sections" type="SECTION">
        {(provided, snapshot) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {data.sections.map((section, index) => {
              return (
                <Draggable
                  key={section.section_title}
                  draggableId={section.section_title}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={getAiChatOutlineStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style,
                      )}
                    >
                      <Box className={classes.header}>
                        <span
                          {...provided.dragHandleProps}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <DragIcon
                            color="inherit"
                            fontSize="small"
                            className={classes.subHeaderDragIcon}
                          />
                        </span>

                        <CoreTextField
                          id={section.section_title.replace(/\s/g, '')}
                          defaultValue={section.section_title}
                          key={section.section_title}
                          size="medium"
                          variant="standard"
                          multiline
                          line={1}
                          maxRows={3}
                          style={{ borderBottom: 0, minWidth: '75%' }}
                          placeholder="Edit Your Outline Header"
                          onBlur={e => handleHeaderItemChange(e, index)}
                        />
                        <div className={classes.flexGrow}></div>
                        <span className={classes.headerButtons}>
                          <EditIcon
                            color="inherit"
                            fontSize="small"
                            className={classes.button}
                            onClick={() =>
                              inputFocus(
                                section.section_title.replace(/\s/g, ''),
                              )
                            }
                          />
                          <DeleteIcon
                            color="inherit"
                            fontSize="small"
                            className={classes.button}
                            onClick={() => deleteHeader(index)}
                          />
                        </span>
                      </Box>
                      <Box m={1}></Box>
                      <SubHeaders
                        completeData={data}
                        data={section.modules}
                        moduleIndex={index}
                        handleSubHeaderItemChange={handleSubHeaderItemChange}
                        deleteSubheader={deleteSubheader}
                        addOwnSubheader={addOwnSubheader}
                        setData={setData}
                        outlineId={outlineId}
                        titles={titles}
                      />
                    </div>
                  )}
                </Draggable>
              )
            })}
            {provided.placeholder}
            <CoreButton
              variant="text"
              size="small"
              color="disabled"
              onClick={() => addOwnHeader()}
            >
              <AddIcon
                fontSize="small"
                style={{
                  color: '#637381',
                }}
              />
              Add a Section
            </CoreButton>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default withStyles(styles)(OutlineList)
